/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ListSubheader from '@material-ui/core/ListSubheader';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { VariableSizeList } from 'react-window';
import { Tooltip, Typography } from '@material-ui/core';
import './baseStyle.css';

const LISTBOX_PADDING = 4; // px

function renderRow(props) {
  const { data, index, style } = props;
  return React.cloneElement(data[index], {
    style: {
      ...style,
      top: style.top + LISTBOX_PADDING,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      // paddingTop: '8px',
      // paddingBottom: '8px',
      height: 'max-content',
      // margin: '10px',
      textOverflow: 'ellipsis',
    },
  });
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref,
) {
  const { children, ...other } = props;
  const itemData = React.Children.toArray(children);
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;

  const getChildSize = (child) => {
    if (React.isValidElement(child) && child.type === ListSubheader) {
      return 48;
    }

    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          ref={gridRef}
          outerElementType={OuterElementType}
          width="100%"
          innerElementType="div"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
          style={{ overflowX: 'hidden' }}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

ListboxComponent.propTypes = {
  children: PropTypes.node,
};

const useStyles = makeStyles({
  listbox: {
    boxSizing: 'border-box',
    '& ul': {
      padding: 0,
      margin: 0,
    },
  },
  // option: {
  //   paddingTop: (props) =>
  //     props?.optionsStyle?.paddingTop ? props?.optionsStyle?.paddingTop : '3px',
  //   paddingBottom: (props) =>
  //     props?.optionsStyle?.paddingBottom
  //       ? props?.optionsStyle?.paddingBottom
  //       : '3px',
  // },
  '@global': {
    '.MuiAutocomplete-option[aria-selected="true"]': {
      background: '#ededed !important',
    },
  },
});
export default function EnhancedAutoComplete(props) {
  const [inputValue, setInputValue] = React.useState('');
  const classes = useStyles();
  const getDefaultValue = (inputProps) => {
    if (inputProps.multiple) {
      if (inputProps.defaultValue) {
        return inputProps.defaultValue;
      } else {
        return [];
      }
    } else {
      if (inputProps.defaultValue) {
        return inputProps.defaultValue;
      } else {
        return null;
      }
    }
  };
  return (
    <Autocomplete
      // open={true}
      tabIndex={props?.tabIndex}
      disabled={props?.disabled}
      multiple={props.multiple ? true : false}
      id={props.id}
      key={props.key ? props.key : props.id}
      style={{ width: '100%' }}
      classes={classes}
      // inputValue={inputValue}
      filterOptions={props?.filterOptions}
      disableCloseOnSelect={
        props.disableCloseOnSelect ? props.disableCloseOnSelect : false
      }
      {...(props.id && props.id=="searchEntityAssociation" ? {value: props.value} : {})}
      defaultValue={getDefaultValue(props)}
     // value={props.value}
      onChange={(e, val) => {
        props.handleOnChange(e, [
          ...props.fixedOptions,
          ...val.filter((option) => props.fixedOptions.indexOf(option) === -1),
        ])
      }}
      ListboxComponent={ListboxComponent}
      required={props.required}
      options={props.options}
      getOptionSelected={props.getOptionSelected}
      renderTags={props.renderTags}
      getOptionLabel={(option) => {
        return props.getOptionLabel(option);
      }}
      renderOption={(option, { selected }) => {
        return props.renderOptionFunction(option, selected);
      }}
      renderInput={(params) => {
        return (
          <TextField
            margin={props.margin ? 'normal' : ''}
            inputProps={{ ...params.inputProps, tabIndex: props?.tabIndex }}
            onChange={(e) => setInputValue(e.target.value)}
            onBlur={() => setInputValue('')}
            required={props.required}
            error={props.error}
            helperText={props.helperText}
            {...params}
            variant="outlined"
            label={props.label}
          />
        );
      }}
    />
  );
}

EnhancedAutoComplete.defaultProps = {
  fixedOptions: [],
  value: []
}

